import React, {useState} from 'react';
import Layout from "@/components/layout/main";
import {useTranslation} from "next-i18next";
import {useRouter} from "next/router";
import SimpleCard from "@/base/components/dashboard/SimpleCart";
import {useNotification} from "@/base/components/NotificationProvider";
import {useUser} from "@/base/components/auth/UserProvider";
import SupportLayout from "@/base/components/layouts/support";
import {Loading} from "@/base/components/Loading";
import {SupportTicket} from "@/base/types/SupportTicket";
import ReCaptchaParent, {useCaptcha} from "@/base/utils/recaptcha";
import MetaBlock from "@/base/components/MetaBlock";
import {SupportChat} from "@/base/components/support/SupportChat";

type Props = {}

export default function Page({}: Props) {
	const {t} = useTranslation();

	const {executeRecaptcha} = useCaptcha();

	const router = useRouter();

	const UserContext = useUser();
	const [api] = useNotification();

	const [loading, setLoading] = useState<boolean>(false);

	const [maxHeight, setMaxHeight] = useState<number>(400);

	const initialText = router.query['text'] as string || '';

	const onChangeTicket = async (ticket?: SupportTicket) => {
		if (!ticket)
		{
			return;
		}

		setLoading(true);

		return router.push({
			pathname: `/support/${ticket.id}`,
			query: {
				'refresh_list': 'true'
			}
		}, undefined, {
			scroll: false,
		}).finally(() => {
			setLoading(false);
		});
	}

	return <SimpleCard
		className={`lg:col-span-8 !shadow-none !rounded-none h-full min-h-[700px]`}
		bodyClassName={` w-full h-full !p-0 flex`}
		headerClassName={`grow-0 w-full`}
	>
		<Loading show={loading} className={` bg-gradient-to-bl from-primary-50/10 to-primary-300/20 lg:!p-6 py-6 px-2 pb-2 w-full h-full`} innerClassName={`h-full`}>
			<SupportChat
				loading={loading}
				maxHeight={maxHeight}
				supportTicket={undefined}
				className={`h-full`}
				onChangeTicket={onChangeTicket}
				initialText={initialText}
				beforeChildren={<div className={`flex-grow-0 flex-shrink-0 flex items-center justify-between`}>
					<h2 className={`h4 !mr-auto max-lg:px-6`}>{t('base-support:ticket-create.title', {
						id: 12
					})}</h2>
					<div className={`flex-grow-0 flex-shrink-0 flex items-center justify-end`}>

					</div>
				</div>}
			/>
		</Loading>
	</SimpleCard>
};

Page.getLayout = function getLayout(page: any) {
	return <Layout rootClassName={`!bg-slate-10 dark:!bg-transparent`}>
		<SupportLayout className={`max-h-[864px] h-full my-auto`} title={t => t('base-support:meta.create.title')}>
			<ReCaptchaParent>
				<MetaBlock
					title={t => t('base-support:meta.create.title')}
					description={t => t('base-support:meta.create.description')}
				/>
				{page}
			</ReCaptchaParent>
		</SupportLayout>
	</Layout>;
};